export var shopDrawerData= [
  {
    type: 'item',
    title: '敬请期待...',
    icon: 'mdi-drama-masks',
    //pageId: `guid-p-u-1`
  },

]